import "../../../src/App.css";
import Department from "../../components/Department/Department";
import AddDepartment from "../../components/AddDepartment/AddDepartment";
import DepartmentList from "../../components/DepartmentList/DepartmentList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import PaginationLink from "../../components/Pagination/Pagination";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function DepartmentMaster() {
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState();
  const [successMessage, setSuccessMessage] = useState(null);
  const [filterCityData, setFilterCityData] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const title = "Add Department";
  const heading = "Department List";

  function tokenStorage() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETDepartment?department=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setUserDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };
  useEffect(() => {
    tokenStorage()
  }, []);

  //console.log(userDetailResponse);
  const GetId = (param) => {
    setSelectedDepartmentId(param);

  };

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div className="container-fluid" style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}>
          <div className="d-flex flex-column w-100" style={{ backgroundColor: "#F4F4F4" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}>
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Department Master| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Master</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}                  
                  setOpenProfile = {setOpenProfile}
                  setFilterCityData = {setFilterCityData}
                  filterCityData = {filterCityData}
                />
                {openAddProfile ? <AddDepartment tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} /> : null}
                {openProfile ? (<Department tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} selectedDepartmentId={selectedDepartmentId} successMessage={successMessage} setSuccessMessage={setSuccessMessage} />) : null}
                <DepartmentList
                  userDetailResponse={userDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}
                  openAddProfile = {openAddProfile} 
                  setOpenAddProfile = {setOpenAddProfile}
                />
                <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DepartmentMaster;
